<!-- На эту страницу мы попадаем при переходе по ссылке из письма -->
<!-- в письме идет запрос к бэкенду после чего редирект на эту страницу -->
<template>
	<v-card>
		<v-card-text>
			<h3 class="mt-10">{{ message }}</h3>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from "axios";
import { mapMutations, mapGetters } from "vuex"
export default {
	name: "ConfirmationPage",

	components: {},
	data: () => ({
		message: "???",
		params: undefined,
	}),
	methods: {
    ...mapMutations('common',["setUser"]),

    async refreshToken(token){
      const proxy = this.getProxy
      const apiUrl= this.getBackendApiUrl

      const refresh = await axios.post(`${proxy}${apiUrl}auth/refresh`, {refreshToken: token}, {
        headers: {"Content-Type": "application/json"},
      })
      if (refresh.status === 200 && refresh.data.status === "ok") {
        this.setUser({
          email: refresh.data.email,
          accessToken: refresh.data.accessToken,
          refreshToken: refresh.data.refreshToken,
        })

        return true
      }else {
        return false
      }

    },
	},
	computed: {
    ...mapGetters('common',["getProxy", "getBackendApiUrl"]),
  },
	async created() {
    // + this.params.get("result")
    this.params = new URL(document.location).searchParams
    //console.log("this.params")
    //console.log(this.params)
    const result = this.params.get("result")
    if (result === "success") {
      const token = this.params.get("token")
      const result = await this.refreshToken(token)
      if (result) {
        this.message = this.$t("ConfirmationEmailPage.activation_account_success")
        this.$router.push({ name: "MainPage" })
      }else {
        this.message = this.$t("ConfirmationEmailPage.activation_account_fail")
      }
    } else {
      this.message = this.$t("ConfirmationEmailPage.activation_account_fail")
    }
  },
}
</script>
